import actions from '@/store/pageContent/actions';

const pageContentModule = {
  state: () => ({
    pageContent: {},
    pageContentBlock: [],
    uploadedImage: {},
    selectedPageId: null,
    galleries: [],
    collectionFolders: [],
  }),
  mutations: {
    GET_PAGE_CONTENT_SUCCESS(state, payload) {
      state.pageContent = payload;
    },
    GET_PAGE_CONTENT_BLOCK_SUCCESS(state, payload) {
      state.pageContentBlock = payload;
    },
    SET_SELECTED_PAGE_ID(state, pageId) {
      state.selectedPageId = pageId;
    },
    SET_GALLERIES(state, payload) {
      state.galleries = payload;
    },
    CLEAR_PAGE_CONTENT(state) {
      state.pageContent = [];
    },
    SET_COLLECTION_FOLDERS(state, payload) {
      state.collectionFolders = payload;
    },
  },
  actions,
  namespaced: true,
};

export default pageContentModule;
